import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetAimsDocumentTypeParams extends PaginationProps {}

interface CreateAimsDocumentType {
  name: string;
}

interface UpdateAimsDocumentType extends CreateAimsDocumentType {
  id: number | null;
}

export async function getAimsDocumentTypes() {
  const { data } = await api.get('/aims-document-types');
  return data;
}

export async function getAimsDocumentTypesMasterData(
  params: GetAimsDocumentTypeParams
) {
  const { data } = await api.get('/aims-document-types/master-data', {
    params
  });
  return data;
}

export async function getAimsDocumentType(id: number) {
  const { data } = await api.get(`/aims-document-types/${id}`);
  return data;
}

export async function createAimsDocumentType(
  createAimsDocumentType: CreateAimsDocumentType
) {
  const { data } = await api.post(
    '/aims-document-types',
    createAimsDocumentType
  );
  return data;
}

export async function updateAimsDocumentType(
  updateAimsDocumentType: UpdateAimsDocumentType
) {
  const { data } = await api.put(
    `/aims-document-types/${updateAimsDocumentType.id}`,
    updateAimsDocumentType
  );
  return data;
}

export function deleteAimsDocumentType(id: number) {
  return api.delete(`/aims-document-types/${id}`);
}
